import './Footer.css';

const Footer = () => {
    return (
        <section id="Footer" className="flex">
            <p>© Jeffery Xie 2024</p>
        </section>
    )
}

export default Footer;